import app from 'flarum/forum/app';
import areAdsBypassed from './areAdsBypassed';
import RefreshAds from './RefreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';
import isDevelopment from './isDevelopment';
export default function InsertFooterAd() {
  setTimeout(() => {
    if (areAdsBypassed()) return;
    const dev = isDevelopment();
    const AdCode = app.data['nagusi-ext-ads.ad-code.footer'];
    const Script = app.data['nagusi-ext-ads.ad-code.footer.js'];
    const footer = document.createElement('footer');
    footer.className = 'nagusi-ad nagusi-ad-footer';
    footer.setAttribute('align', 'center');
    document.querySelector('.App-content').append(footer);
    footer.innerHTML = dev ? '<p>Anuncio</p>' : AdCode;
    if (dev) return;

    // Hacky way to detect URL change and re-create ad tag

    const pushState = history.pushState;
    history.pushState = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      pushState.apply(history, args);
      footer.innerHTML = AdCode;
      RefreshAds();
      safelyEvalAdScript('footer', Script);
    };
    RefreshAds();
  }, 0);
}